<template>
  <a :href="href" :target="target">
    <slot></slot>
  </a>
</template>

<script>
import { languageAdapter } from "@/services/languageAdapter";
import { createPdfDownloadUrl } from "@/services/urlBuilder.js";

export default {
  name: "PdfDocument",
  props: {
    // use either url or name
    url: { type: String, required: false },
    name: { type: String, required: false }
  },
  computed: {
    href() {
      if (this.name) {
        const { pdfs, isPwaModeActive, language } = this.$store.state;
        const { path, url } = pdfs[language][this.name];
        return isPwaModeActive ? createPdfDownloadUrl({ path, url }) : url;
      }
      return this.url;
    },
    target() {
      return "_blank";
    }
  }
};
</script>

<style scoped>
button {
  text-align: left;
}
</style>
